export function accessibleCards() {
  var cards = document.querySelectorAll('.has-link');

  cards.forEach(function (card) {
    var link = card.querySelector('.link');
    if (link) {
      // Regular mouse button.
      card.addEventListener('click', function () {
        link.click();
      });
      // Middle mouse button.
      card.addEventListener('mouseup', function (e) {
        if (typeof e === 'object' && e.button === 1) {
          link.click();
        }
      });
      link.addEventListener('focus', function () {
        card.classList.add('has-focus');
      });
      link.addEventListener('blur', function () {
        card.classList.remove('has-focus');
      });
      card.addEventListener('mouseover', function () {
        card.classList.add('has-hover');
      });
      card.addEventListener('mouseout', function () {
        card.classList.remove('has-hover');
      });
    }
  });
}